export interface Option {
  label: string;
  value: string;
}

export const houseTypes: Option[] = [
  { label: 'Apartment', value: 'apartment' },
  { label: 'Villa', value: 'villa' },
  { label: 'Studio', value: 'studio' },
];

export const cities: Option[] = [
  { label: 'New York', value: 'new-york' },
  { label: 'Los Angeles', value: 'los-angeles' },
  { label: 'Chicago', value: 'chicago' },
];

export const states: Option[] = [
  { label: 'New York', value: 'ny' },
  { label: 'California', value: 'ca' },
  { label: 'Illinois', value: 'il' },
];

export const sizeUnits: Option[] = [
  { label: 'sq ft', value: 'sqft' },
  { label: 'sq m', value: 'sqm' },
];

export const furnishedOptions: Option[] = [
  { label: 'Furnished', value: 'furnished' },
  { label: 'Unfurnished', value: 'unfurnished' },
];

export const currencyOptions: Option[] = [{ label: 'USD', value: 'usd' }];

export const availabilityOptions: Option[] = [
  { label: 'Available', value: 'ACTIVE' },
  { label: 'Not Available', value: 'INACTIVE' },
];
